import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/var/www/mypawn/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});




/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "css/app.css",
    "revision": "7e295db485dfb327a9e360e1e583aa51"
  },
  {
    "url": "favicon.ico",
    "revision": "d41d8cd98f00b204e9800998ecf8427e"
  },
  {
    "url": "favicon.png",
    "revision": "b8a12cc07df743719d1f04952225eddf"
  },
  {
    "url": "fonts/vendor/font-awesome/fontawesome-webfont.eot",
    "revision": "674f50d287a8c48dc19ba404d20fe713"
  },
  {
    "url": "fonts/vendor/font-awesome/fontawesome-webfont.svg",
    "revision": "912ec66d7572ff821749319396470bde"
  },
  {
    "url": "fonts/vendor/font-awesome/fontawesome-webfont.ttf",
    "revision": "b06871f281fee6b241d60582ae9369b9"
  },
  {
    "url": "fonts/vendor/font-awesome/fontawesome-webfont.woff",
    "revision": "fee66e712a8a08eef5805a46892932ad"
  },
  {
    "url": "fonts/vendor/font-awesome/fontawesome-webfont.woff2",
    "revision": "af7ae505a9eed503f8b8e6982036873e"
  },
  {
    "url": "fonts/vendor/simple-line-icons/Simple-Line-Icons.eot",
    "revision": "f33df365d6d0255b586f2920355e94d7"
  },
  {
    "url": "fonts/vendor/simple-line-icons/Simple-Line-Icons.svg",
    "revision": "2fe2efe63441d830b1acd106c1fe8734"
  },
  {
    "url": "fonts/vendor/simple-line-icons/Simple-Line-Icons.ttf",
    "revision": "d2285965fe34b05465047401b8595dd0"
  },
  {
    "url": "fonts/vendor/simple-line-icons/Simple-Line-Icons.woff",
    "revision": "78f07e2c2a535c26ef21d95e41bd7175"
  },
  {
    "url": "fonts/vendor/simple-line-icons/Simple-Line-Icons.woff2",
    "revision": "0cb0b9c589c0624c9c78dd3d83e946f6"
  },
  {
    "url": "images/1.jpg",
    "revision": "4f7fdfc6675d0469eacc4d6c735219ac"
  },
  {
    "url": "images/2.jpg",
    "revision": "480fe440dc6b962a63b6ab017d145380"
  },
  {
    "url": "images/3.jpg",
    "revision": "73e3cc5256255d13f8ee6504e38e48f1"
  },
  {
    "url": "images/4.jpg",
    "revision": "75e0bbd2d3d2831a6d5e387d674a61db"
  },
  {
    "url": "images/5.jpg",
    "revision": "56fb19fbf7dde8f0d717681b39f0dee6"
  },
  {
    "url": "images/6.jpg",
    "revision": "6423e2e662718dd7f20fb7c89b742a9d"
  },
  {
    "url": "images/7.jpg",
    "revision": "f9e66d23438ea709be513b60f66dcb17"
  },
  {
    "url": "images/8.jpg",
    "revision": "960f2560c90216e7e7d715a3470d7080"
  },
  {
    "url": "images/barang/1762399693690c15cdc44b7.jpg",
    "revision": "9e750398cf5944a06183a32329cdff1e"
  },
  {
    "url": "images/barang/17628332866912b386ad836.jpg",
    "revision": "e88561ae77d8d262089e0dc8171017e7"
  },
  {
    "url": "images/barang/1764734297692fb5592fd33.jpg",
    "revision": "7f5272784ebcfa261b5d347ba76a0c0b"
  },
  {
    "url": "images/barang/1764780527693069ef2f70b.jpg",
    "revision": "0da551b418417e1cc7ca29687650610c"
  },
  {
    "url": "images/barang/176478063369306a59e4cb2.jpg",
    "revision": "69339e6a2f8b5ebf2b99e74c8b173dbd"
  },
  {
    "url": "images/barang/176478065269306a6c2c837.jpg",
    "revision": "a8fce43a2f316b972e0b6d2f56aa9eae"
  },
  {
    "url": "images/barang/176478081369306b0de768c.jpg",
    "revision": "e7e93217d9224de0f120dc42ca0642e3"
  },
  {
    "url": "images/barang/176478106169306c057f2b4.jpg",
    "revision": "47cbf65efdfae992078193e376f62b08"
  },
  {
    "url": "images/logo_black.png",
    "revision": "05cf71e5f46f648f80bce1cb8be70bd0"
  },
  {
    "url": "images/logo_mypawn.png",
    "revision": "1a4d93cbd63908146f200c252dc0c093"
  },
  {
    "url": "images/logo-symbol.png",
    "revision": "b8a12cc07df743719d1f04952225eddf"
  },
  {
    "url": "images/logo.png",
    "revision": "1a4d93cbd63908146f200c252dc0c093"
  },
  {
    "url": "images/mypawn_icon_192x192.png",
    "revision": "24cfd98b46cd5dbca40b13add2386b7a"
  },
  {
    "url": "images/mypawn_icon_512x512.png",
    "revision": "ead1189d9cbe1ac1b5dfdd7d3b80a978"
  },
  {
    "url": "images/mypawn_logo_white_200.png",
    "revision": "90b021b600af7da359b6c93c7c142582"
  },
  {
    "url": "images/mypawn_logo_white.png",
    "revision": "6d0346462ecc1c01bbddcc24782c9aa5"
  },
  {
    "url": "images/nasabah/176104030368f757af494de.png",
    "revision": "a10d628862223c9d624d12e03b068610"
  },
  {
    "url": "images/nasabah/17642154266927ca82378d9.jpg",
    "revision": "91c1bf1dac95a5b88bd86fdeb73c8e9b"
  },
  {
    "url": "images/nasabah/1765538418693bfa72368b4.jpg",
    "revision": "a93e9e951327b4664214531d34cb8440"
  },
  {
    "url": "images/nasabah/17803905936a1e9ac1475fb.jpg",
    "revision": "9538cff6ef57848dac3103a5f574f780"
  },
  {
    "url": "images/ojk_black.png",
    "revision": "3e3bc98ebedae78484f4a7a71342a665"
  },
  {
    "url": "images/ojk.png",
    "revision": "7fd7b6a86492e99bb4f63f0ab6d51087"
  },
  {
    "url": "images/ppgi.jpg",
    "revision": "5ee1737722242a9f831797e50d8e1463"
  },
  {
    "url": "index.php",
    "revision": "b9901d13f00ef92e0793e2d9fcd57431"
  },
  {
    "url": "js/manifest.js",
    "revision": "3c768977c2574a34506ebd0fed7ae101"
  },
  {
    "url": "js/vendor.js",
    "revision": "177e30cff476bb3dfe705e00a9760528"
  },
  {
    "url": "manifest.json",
    "revision": "6a2381f70fad5294f82e18ca012629fe"
  },
  {
    "url": "mix-manifest.json",
    "revision": "07c3a71ac85bd03d8bf52a7546ccc751"
  },
  {
    "url": "robots.txt",
    "revision": "b6216d61c03e6ce0c9aea6ca7808f7ca"
  }
], {
  "ignoreURLParametersMatching": [/^utm_/, /^fbclid$/, /^a/]
});








